import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title max-sm-w-100" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_8 = {
  class: "d-flex flex-wrap justify-content-end gap-3 max-sm-w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_order_routing_filter_drown"
}
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = { class: "d-flex gap-3 max-sm-w-100" }
const _hoisted_13 = {
  key: 0,
  type: "button",
  class: "btn btn-light btn-active-light-primary max-sm-btn flex-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_merchant_order_list"
}
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_15 = {
  key: 1,
  class: "svg-icon svg-icon-3"
}
const _hoisted_16 = {
  key: 1,
  class: "me-0"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_19 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_20 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_24 = { class: "menu-item px-3 mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_26 = { class: "menu-item px-3 mb-3" }
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_28 = { class: "menu-item px-3 mb-3" }
const _hoisted_29 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_30 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_31 = {
  class: "d-flex flex-wrap justify-content-end gap-3",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_32 = {
  key: 0,
  type: "button",
  class: "btn btn-light btn-active-light-primary max-sm-btn",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_merchant_order_list"
}
const _hoisted_33 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_34 = {
  key: 1,
  class: "svg-icon svg-icon-3"
}
const _hoisted_35 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_36 = { class: "svg-icon svg-icon-2" }
const _hoisted_37 = {
  key: 1,
  class: "me-0"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_40 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_41 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_42 = { class: "menu-item px-3" }
const _hoisted_43 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_45 = { class: "menu-item px-3 mb-3" }
const _hoisted_46 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_47 = { class: "menu-item px-3 mb-3" }
const _hoisted_48 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_49 = { class: "menu-item px-3 mb-3" }
const _hoisted_50 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_51 = { class: "card-body pt-0" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "fs-7 text-gray-400" }
const _hoisted_54 = { class: "d-flex flex-column text-nowrap" }
const _hoisted_55 = {
  key: 0,
  class: "fs-7 text-danger"
}
const _hoisted_56 = { class: "text-nowrap" }
const _hoisted_57 = { class: "text-uppercase" }
const _hoisted_58 = { class: "fs-7 text-gray-400" }
const _hoisted_59 = { class: "text-uppercase" }
const _hoisted_60 = {
  key: 0,
  class: "text-nowrap",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_61 = {
  class: "btn btn-sm btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_62 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_63 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-175px py-4",
  "data-kt-menu": "true"
}
const _hoisted_64 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 1,
  class: "menu-item px-3"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "menu-item px-3" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_75 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_OrderAssignItem = _resolveComponent("OrderAssignItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _component_MerchantOrderModal = _resolveComponent("MerchantOrderModal")!
  const _component_QuickRouting = _resolveComponent("QuickRouting")!
  const _component_Refuse = _resolveComponent("Refuse")!
  const _component_CancelFulfillmentOrderModal = _resolveComponent("CancelFulfillmentOrderModal")!
  const _component_ReturnRefundModal = _resolveComponent("ReturnRefundModal")!
  const _component_RefundOtherModal = _resolveComponent("RefundOtherModal")!
  const _component_cancel_open_qty = _resolveComponent("cancel-open-qty")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14 max-sm-w-100",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createVNode(_component_window_resize, null, {
          sm: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.options.assignable,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.options.assignable) = $event)),
                    onChange: _ctx.assignableChange,
                    disabled: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.assignableOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "disabled"])
                ]),
                _createElementVNode("button", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                ]),
                _createVNode(_component_FilterDropdown, {
                  orderStatus: _ctx.options.status,
                  fulfillmentStatus: _ctx.options.fulfillment_status,
                  store_id: _ctx.store_id,
                  onSubmitFilter: _ctx.handleFilter,
                  onResetFilter: _ctx.handleFilterReset
                }, null, 8, ["orderStatus", "fulfillmentStatus", "store_id", "onSubmitFilter", "onResetFilter"]),
                _createElementVNode("div", _hoisted_12, [
                  (!_ctx.isMB || _ctx.type === 0)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_13, [
                        (_ctx.disabledmerchantRequest || _ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm004.svg" })
                            ])),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.sendRequest")) + " (" + _toDisplayString(_ctx.options.unassigned_total) + ") ", 1)
                      ])), [
                        [_directive_auth, { auth: ['add'] }]
                      ])
                    : _createCommentVNode("", true),
                  (!_ctx.isMB || _ctx.type === 0)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-bg-light btn-active-color-primary",
                          "data-kt-menu-trigger": "click",
                          "data-kt-menu-placement": "bottom-end",
                          "data-kt-menu-flip": "top-end",
                          disabled: 
                      _ctx.disabledExportUnderstockEqualization ||
                      _ctx.disabledExportFulfillmentRejectedItems ||
                      _ctx.loading
                    
                        }, [
                          (
                        _ctx.disabledExportUnderstockEqualization ||
                        _ctx.disabledExportFulfillmentRejectedItems
                      )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                            : (_openBlock(), _createElementBlock("i", _hoisted_19))
                        ], 8, _hoisted_17),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t("common.export")), 1)
                          ]),
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["menu-link px-3", {
                          disabled:
                            _ctx.disabledExportUnderstockEqualization || _ctx.loading,
                        }]),
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fileExportUnderstockEqualization && _ctx.fileExportUnderstockEqualization(...args))),
                              style: {"font-size":"normal"}
                            }, [
                              (
                            _ctx.disabledExportUnderstockEqualization && !_ctx.loading
                          )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.exportUnderstockEqualization")), 1)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["menu-link px-3", {
                          disabled:
                            _ctx.disabledExportFulfillmentRejectedItems || _ctx.loading,
                        }]),
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileExportFulfillmentRejectedItems && _ctx.fileExportFulfillmentRejectedItems(...args))),
                              style: {"font-size":"normal"}
                            }, [
                              (
                            _ctx.disabledExportFulfillmentRejectedItems && !_ctx.loading
                          )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.exportFulfillmentRejectedItems")), 1)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["menu-link px-3", {
                          disabled: _ctx.disabledExport || _ctx.loading,
                        }]),
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.filesExport && _ctx.filesExport(...args))),
                              style: {"font-size":"normal"}
                            }, [
                              (_ctx.disabledExport && !_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.export")), 1)
                            ], 2)
                          ])
                        ])
                      ])), [
                        [_directive_auth, { auth: ['export'] }]
                      ])
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          lg: _withCtx(() => [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (!_ctx.isMB || _ctx.type === 0)
                  ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_32, [
                      (_ctx.disabledmerchantRequest || _ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                        : (_openBlock(), _createElementBlock("span", _hoisted_34, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm004.svg" })
                          ])),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.sendRequest")) + " (" + _toDisplayString(_ctx.options.unassigned_total) + ") ", 1)
                    ])), [
                      [_directive_auth, { auth: ['add'] }]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.options.assignable,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.options.assignable) = $event)),
                    onChange: _ctx.assignableChange,
                    disabled: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.assignableOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "disabled"])
                ]),
                _createElementVNode("button", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                ]),
                _createVNode(_component_FilterDropdown, {
                  orderStatus: _ctx.options.status,
                  fulfillmentStatus: _ctx.options.fulfillment_status,
                  store_id: _ctx.store_id,
                  onSubmitFilter: _ctx.handleFilter,
                  onResetFilter: _ctx.handleFilterReset
                }, null, 8, ["orderStatus", "fulfillmentStatus", "store_id", "onSubmitFilter", "onResetFilter"]),
                (!_ctx.isMB || _ctx.type === 0)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-bg-light btn-active-color-primary",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end",
                        disabled: 
                    _ctx.disabledExportUnderstockEqualization ||
                    _ctx.disabledExportFulfillmentRejectedItems ||
                    _ctx.loading
                  
                      }, [
                        (
                      _ctx.disabledExportUnderstockEqualization ||
                      _ctx.disabledExportFulfillmentRejectedItems
                    )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39))
                          : (_openBlock(), _createElementBlock("i", _hoisted_40))
                      ], 8, _hoisted_38),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.t("common.export")), 1)
                        ]),
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu-link px-3", {
                        disabled:
                          _ctx.disabledExportUnderstockEqualization || _ctx.loading,
                      }]),
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.fileExportUnderstockEqualization && _ctx.fileExportUnderstockEqualization(...args))),
                            style: {"font-size":"normal"}
                          }, [
                            (_ctx.disabledExportUnderstockEqualization && !_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.exportUnderstockEqualization")), 1)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu-link px-3", {
                        disabled:
                          _ctx.disabledExportFulfillmentRejectedItems || _ctx.loading,
                      }]),
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.fileExportFulfillmentRejectedItems && _ctx.fileExportFulfillmentRejectedItems(...args))),
                            style: {"font-size":"normal"}
                          }, [
                            (
                          _ctx.disabledExportFulfillmentRejectedItems && !_ctx.loading
                        )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.exportFulfillmentRejectedItems")), 1)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu-link px-3", {
                        disabled: _ctx.disabledExport || _ctx.loading,
                      }]),
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.filesExport && _ctx.filesExport(...args))),
                            style: {"font-size":"normal"}
                          }, [
                            (_ctx.disabledExport && !_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.export")), 1)
                          ], 2)
                        ])
                      ])
                    ])), [
                      [_directive_auth, { auth: ['export'] }]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(_component_MBDatatablePlus, {
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.doubleSaleTableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          order: "desc",
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-sub": _withCtx(({ row: item }) => [
            (_openBlock(), _createBlock(_component_OrderAssignItem, {
              ref: 'orderAssignItem.' + item.id,
              type: _ctx.type,
              key: item.id,
              itemId: item.id,
              subId: item.id,
              onRefuse: _ctx.refuseSubItem,
              onCancel: _ctx.cancelSubItem
            }, null, 8, ["type", "itemId", "subId", "onRefuse", "onCancel"]))
          ]),
          "cell-order_number": _withCtx(({ row: item }) => [
            _createVNode(_component_el_popover, {
              placement: "top",
              width: "auto",
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: 
                    '/sales-order/order-overview/' + item.order_id + '/overview'
                  ,
                    onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                    class: "text-gray-800 text-hover-primary text-nowrap"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.order_number), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_53, " SUB#" + _toDisplayString(item.position) + " of " + _toDisplayString(item.total_item_count), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (item.order_number != item.old_order_number)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(item.old_order_number) + ", ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(item.order_number_encry), 1)
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          "cell-due_date": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.due_date)), 1),
              (_ctx.getLateDays(item.due_date) > 0 && item.min_qty > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.t("common.agoDays", [_ctx.getLateDays(item.due_date)])), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          "cell-priority_level": _withCtx(({ row: item }) => [
            (item.relation_priority_management.priority_level)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["svg-icon svg-icon-2", 
              _ctx.getSalesOrderPriorityLevelSvgStyleMap(
                item.relation_priority_management.priority_level
              )
            ])
                }, [
                  _createVNode(_component_inline_svg_icon, {
                    src: 
                _ctx.getSalesOrderPriorityLevelMap(
                  item.relation_priority_management.priority_level
                )
              
                  }, null, 8, ["src"])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          "cell-article": _withCtx(({ row: item }) => [
            _createVNode(_component_product_info, {
              gallery: item.relation_sku.gallery,
              name: item.relation_sku.name,
              name_en: item.relation_sku.name_en,
              source_link: item.relation_sku.source_link,
              brand_id: item.relation_sku.brand
            }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
          ]),
          "cell-sku": _withCtx(({ row: item }) => [
            _createVNode(_component_sku_info, {
              brand_article_no: 
              item.relation_sku.brand_article_no
                ? item.relation_sku.brand_article_no
                : item.relation_sku.merchant_article_no
            ,
              color: item.relation_sku.original_color,
              size: item.relation_sku.size,
              product_identifier_id: '0'
            }, null, 8, ["brand_article_no", "color", "size"])
          ]),
          "cell-qty": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.ordered_qty), 1)
          ]),
          "cell-qty_ctrl": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", {
                class: _normalizeClass({
                'text-danger':
                  item.inventory_warning === 1 && item.open_qty > 0,
              })
              }, [
                _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.t("orderAssign.open")), 1),
                _createTextVNode(": " + _toDisplayString(item.open_qty), 1)
              ], 2),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.t("orderAssign.min")), 1),
                _createTextVNode(": " + _toDisplayString(item.min_qty), 1)
              ])
            ])
          ]),
          "cell-order_status": _withCtx(({ row: item }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge text-uppercase", _ctx.orderStatus(item.relation_sales_order.status)])
            }, _toDisplayString(item.__show.status), 3)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            (
              _ctx.checkPermissionFlag(
                { auth: ['add', 'update'] },
                item.open_qty > 0
              ) ||
              _ctx.checkPermissionFlag({ auth: ['export', 'update'] }) ||
              _ctx.checkPermissionFlag(
                { auth: ['customer_cancel_open_qty'] },
                item.allow_cancel_qty > 0
              ) ||
              _ctx.checkPermissionFlag(
                { auth: ['customer_return'] },
                item.open_qty != item.ordered_qty
              )
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _createElementVNode("button", _hoisted_61, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.action")), 1),
                    _createElementVNode("span", _hoisted_62, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_permission_common, { role: { auth: ['customer_cancel_open_qty'] } }, {
                      default: _withCtx(() => [
                        (item.allow_cancel_qty > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              _createElementVNode("div", {
                                class: "menu-link px-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_routing_overview_cancel_open_qty",
                                onClick: ($event: any) => (_ctx.quickRoutingItem(item))
                              }, _toDisplayString(_ctx.t("orderRefund.cancelOpenQty")), 9, _hoisted_65)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_permission_common, { role: { auth: ['customer_return'] } }, {
                      default: _withCtx(() => [
                        (_ctx.isDepositOrFullPaymentOrders(item) && (item.open_qty != item.ordered_qty))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _createElementVNode("div", {
                                class: "menu-link px-3",
                                onClick: ($event: any) => (_ctx.goToRefundPage(item))
                              }, _toDisplayString(_ctx.t("orderRefund.refund")), 9, _hoisted_67)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isDepositOrFullPaymentOrders(item) && (item.open_qty != item.ordered_qty))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                              _createElementVNode("div", {
                                class: "menu-link px-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_routing_overview_return",
                                onClick: ($event: any) => (_ctx.goToRefundPage(item, true))
                              }, _toDisplayString(_ctx.t("orderRefund.returnRefund")), 9, _hoisted_69)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_permission_common, { role: { auth: ['customer_return'] } }, {
                      default: _withCtx(() => [
                        (!_ctx.isDepositOrFullPaymentOrders(item) && (item.open_qty != item.ordered_qty))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _createElementVNode("div", {
                                class: "menu-link px-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_routing_overview_return_other",
                                onClick: ($event: any) => (_ctx.quickRoutingItem(item))
                              }, _toDisplayString(_ctx.t("orderAssign.return")), 9, _hoisted_71)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["menu-link px-3", {
                    disabled: item.downloadDisabled,
                    'opacity-50': item.downloadDisabled,
                    'cursor-nodrop': item.downloadDisabled,
                  }]),
                        onClick: ($event: any) => (_ctx.fileExport(item.order_number, item))
                      }, _toDisplayString(_ctx.t("orderAssign.exportPriorityEqualization")), 11, _hoisted_73)
                    ])), [
                      [_directive_auth, { auth: ['export', 'update'] }]
                    ]),
                    _createVNode(_component_permission_common, { role: { auth: ['add', 'update'] } }, {
                      default: _withCtx(() => [
                        (item.open_qty > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              _createElementVNode("div", {
                                class: "menu-link px-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_edit_quick_routing",
                                onClick: ($event: any) => (_ctx.quickRoutingItem(item))
                              }, _toDisplayString(_ctx.t("orderAssign.quickRouting")), 9, _hoisted_75)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_MerchantOrderModal, {
      store_id: _ctx.store_id,
      onUpdateList: _ctx.updateList
    }, null, 8, ["store_id", "onUpdateList"]),
    _createVNode(_component_QuickRouting, {
      user_type: _ctx.store.getters.currentUser.user_type,
      tableItemData: _ctx.tableItemData,
      onUpdateList: _ctx.updateList,
      onResetForm: _ctx.handleResetQuickRouting
    }, null, 8, ["user_type", "tableItemData", "onUpdateList", "onResetForm"]),
    _createVNode(_component_Refuse, {
      orderId: _ctx.itemId,
      id: _ctx.subId,
      onUpdateList: _ctx.updateList
    }, null, 8, ["orderId", "id", "onUpdateList"]),
    _createVNode(_component_CancelFulfillmentOrderModal, {
      onUpdateList: _ctx.updateList,
      id: _ctx.subId
    }, null, 8, ["onUpdateList", "id"]),
    _createVNode(_component_ReturnRefundModal, {
      tableItemData: _ctx.tableItemData,
      onUpdateList: _ctx.updateList,
      onResetForm: _ctx.handleResetQuickRouting,
      onContinueReturnRefund: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToRefundPage($event, true, true)))
    }, null, 8, ["tableItemData", "onUpdateList", "onResetForm"]),
    _createVNode(_component_RefundOtherModal, {
      tableItemData: _ctx.tableItemData,
      onUpdateList: _ctx.updateList,
      onResetForm: _ctx.handleResetQuickRouting
    }, null, 8, ["tableItemData", "onUpdateList", "onResetForm"]),
    _createVNode(_component_cancel_open_qty, {
      tableItemData: _ctx.tableItemData,
      onUpdateList: _ctx.updateList,
      onResetForm: _ctx.handleResetQuickRouting
    }, null, 8, ["tableItemData", "onUpdateList", "onResetForm"])
  ], 64))
}